import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Loader from "components/loader/Loader";
import CommonSubHeader from "components/commonSubHeader/CommonSubHeader";
import CommonTable from "components/commonTable/CommonTable";
import Dashboard from "./Dashboard";
import Billing from "pages/billing/Billing";
import { rolesEnum } from "utils/enumObj";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import CommonAutoComplete from "components/commonAutoComplete/CommonAutoComplete";
import { uploadEmployeeExcel } from "redux/actions/EmployeesAction";
import { useDispatch } from "react-redux";
import CommonModal from "components/commonModal/CommonModal";
import BulkEmployeeUpload from "components/bulkEmployeeUpload/BulkEmployeeUpload";
import BulkEmployeeUploadResultModal from "components/bulkEmployeeUpload/BulkEmployeeUploadResultModal";

const FrontDeskTablist = (props) => {
  const {
    page,
    tab,
    search,
    rowsPerPage,
    filterData,
    status,
    onFilterChange,
    onRestFilter,
    employeesListTable,
    bookingList,
    handleTab,
    handleChangePage,
    handleChangeRowsPerPage,
    onSelectDateRange,
    onSearchQuery,
    filterHistoryData,
    loaderBooking,
    onClickMoreIcon,
    dateFrom,
    dateTo,
    dashBorardUpperData,
    onApproveEmployee,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loader = false;

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [failedRows, setFailedRows] = useState([]);

  const handleTabChange = (event, newValue) => {
    handleTab(newValue);
  };

  const role = localStorage.getItem("role");

  const profile =
    localStorage?.getItem("user") && JSON.parse(localStorage?.getItem("user"));

  const handlePage = () => {
    if (tab === "all") {
      navigate("/front-desk/new-booking");
    } else {
      navigate("/front-desk/new-employee");
    }
  };

  const handleBulkUploadResult = (failed) => {
    setBulkUploadModal(false);

    setFailedRows(failed);

    setResultModal(true);
  };

  const onClickTableRow = (navigate, val) => {
    switch (tab) {
      case "all":
      case "history":
      case "dashboard":
        return navigate(`/front-desk/bookingdetails`, {
          state: { id: val?.id, page: "front-desk" },
        });
      case "employeeProfiles":
        return navigate("/front-desk/new-employee", {
          state: { id: val?.id, type: "edit" },
        });
      default:
        return navigate(`/front-desk/bookingdetails`, {
          state: { id: val?.id, page: "front-desk" },
        });
    }
  };

  // const employeeTableData = {
  //   ...employeesListTable,
  //   header: employeesListTable?.header?.some(
  //     (item) => item.key === "approvalStatus",
  //   )
  //     ? employeesListTable.header
  //     : [
  //         ...(employeesListTable?.header || []),
  //         {
  //           label: "Status",
  //           key: "approvalStatus",
  //         },
  //       ],
  // };

  const employeeTableData = {
    ...employeesListTable,
    header: employeesListTable?.header?.some(
      (item) => item.key === "approvalStatus",
    )
      ? employeesListTable.header.some((item) => item.key === "action")
        ? employeesListTable.header
        : [
            ...employeesListTable.header,
            {
              label: "Action",
              key: "action",
            },
          ]
      : [
          ...(employeesListTable?.header || []),
          {
            label: "Status",
            key: "approvalStatus",
          },
          {
            label: "Action",
            key: "action",
          },
        ],
  };

  return (
    <Box className="plr20 mb20">
      {loader ? (
        <Loader height="50vh" />
      ) : (
        <Grid container>
          <Grid item className="tabContainer frontDeskTabContainer" xs={12}>
            <Box className="contentBoxStyle">
              <TabContext value={tab}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabList
                      onChange={handleTabChange}
                      aria-label="lab API tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: "transparent" }, // Replace 'none' with your desired color
                      }}
                    >
                      {role !== "3" && (
                        <Tab
                          icon={<SpaceDashboardOutlinedIcon />}
                          iconPosition="start"
                          label="Dashboard"
                          value="dashboard"
                          className="tabStyle"
                        />
                      )}
                      <Tab
                        icon={<CalendarMonthOutlinedIcon />}
                        iconPosition="start"
                        label="All Booking"
                        value="all"
                        className="tabStyle"
                      />
                      {rolesEnum.frontdeskRoles?.includes(
                        Number(profile?.role),
                      ) && (
                        <Tab
                          icon={<PeopleAltOutlinedIcon />}
                          iconPosition="start"
                          label="Employee Profiles"
                          value="employeeProfiles"
                          className="tabStyle"
                        />
                      )}
                      <Tab
                        icon={<PendingActionsOutlinedIcon />}
                        iconPosition="start"
                        label="History"
                        value="history"
                        className="tabStyle"
                      />
                      {/* TODO: Has now commented the code for Demo purpose on 31-01-2024 */}
                      {/* <Tab
                        label="Billing"
                        value="billing"
                        className="tabStyle"
                      /> */}
                    </TabList>
                  </Grid>
                  {parseFloat(role) !== rolesEnum?.employee && (
                    <Grid className="w400">
                      <CommonAutoComplete />
                    </Grid>
                  )}
                </Grid>
                <Box className="dashedBorder mt20 mb20"></Box>
                {parseInt(role) !== rolesEnum?.employee && (
                  <TabPanel
                    value="dashboard"
                    sx={{ width: "100%" }}
                    className="frontDeskTable"
                  >
                    <Box className="mb20">
                      <CommonSubHeader
                        filterStatus={false}
                        dateRange={true}
                        tabName={tab}
                        showSearch={false}
                        onSearchQuery={onSearchQuery}
                        onSelectDateRange={onSelectDateRange}
                        tab={tab}
                        dateFrom={dateFrom}
                        dateTo={dateTo}
                        search={search}
                      />
                    </Box>
                    <Box className="mb20">
                      <Dashboard dashBorardUpperData={dashBorardUpperData} />
                    </Box>
                    <Typography variant={"head5"} className=" fw600">
                      Trips Details
                    </Typography>
                    {loaderBooking ? (
                      <Loader height="50vh" />
                    ) : (
                      <CommonTable
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        tableOnClickRow={onClickTableRow}
                        data={bookingList}
                        tabName={"booking"}
                        onClickMoreIcon={onClickMoreIcon}
                      />
                    )}
                  </TabPanel>
                )}
                <TabPanel
                  value="all"
                  sx={{ width: "100%" }}
                  className="frontDeskTable"
                >
                  <Box className="mb20">
                    <CommonSubHeader
                      filterStatus={true}
                      dateRange={true}
                      tabName={tab}
                      filterData={filterData}
                      defaultStatus={status}
                      onFilterChange={onFilterChange}
                      onRestFilter={onRestFilter}
                      showSearch={true}
                      onSearchQuery={onSearchQuery}
                      buttonName={"New Booking"}
                      onSelectDateRange={onSelectDateRange}
                      navigation={() => handlePage()}
                      tab={tab}
                      dateFrom={dateFrom}
                      dateTo={dateTo}
                      search={search}
                    />
                  </Box>

                  <Box className="tripLegend mb10">
                    <span className="legendItem">
                      <span className="legendColor amber"></span>
                      No Vehicle - Within 4 Hours
                    </span>

                    <span className="legendItem ml20">
                      <span className="legendColor red"></span>
                      No Vehicle - Within 2 Hours
                    </span>
                  </Box>

                  {loaderBooking ? (
                    <Loader height="50vh" />
                  ) : (
                    <CommonTable
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={handleChangePage}
                      handleChangeRowsPerPage={handleChangeRowsPerPage}
                      tableOnClickRow={onClickTableRow}
                      data={bookingList}
                      tabName={"booking"}
                      enableTripHighlight={true}
                      onClickMoreIcon={onClickMoreIcon}
                    />
                  )}
                </TabPanel>

                <TabPanel value="employeeProfiles" className="frontDeskTable">
                  <Box className="mb20">
                    {/* <CommonSubHeader
                      showSearch={true}
                      onSearchQuery={onSearchQuery}
                      buttonName={role === "2" ? "Add employee" : ""}
                      navigation={() => handlePage()}
                      search={search}
                    /> */}

                    <CommonSubHeader
                      showSearch={true}
                      onSearchQuery={onSearchQuery}
                      buttonName={role === "2" ? "Add employee" : ""}
                      navigation={() => handlePage()}
                      search={search}
                      showUploadExcel={true}
                      openBulkUpload={() => setBulkUploadModal(true)}
                    />
                  </Box>

                  {/* <CommonTable
                    tableOnClickRow={onClickTableRow}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    data={employeesListTable}
                  /> */}

                  <CommonTable
                    tableOnClickRow={onClickTableRow}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    data={employeeTableData}
                    onApproveEmployee={onApproveEmployee}
                  />

                  <CommonModal
                    open={bulkUploadModal}
                    handleClose={() => setBulkUploadModal(false)}
                  >
                    <BulkEmployeeUpload
                      handleClose={() => setBulkUploadModal(false)}
                      onUploadResult={handleBulkUploadResult}
                    />
                  </CommonModal>

                  <CommonModal
                    open={resultModal}
                    handleClose={() => {
                      setResultModal(false);
                      setFailedRows([]);
                    }}
                  >
                    <BulkEmployeeUploadResultModal
                      failedRows={failedRows}
                      handleClose={() => {
                        setResultModal(false);
                        setFailedRows([]);
                      }}
                    />
                  </CommonModal>
                </TabPanel>
                <TabPanel value="history" className="frontDeskTable">
                  <Box className="mb20">
                    <CommonSubHeader
                      filterStatus={true}
                      dateRange={true}
                      showSearch={true}
                      onSearchQuery={onSearchQuery}
                      filterData={filterHistoryData}
                      defaultStatus={status}
                      onFilterChange={onFilterChange}
                      onRestFilter={onRestFilter}
                      onSelectDateRange={onSelectDateRange}
                      navigation={() => handlePage()}
                      dateFrom={dateFrom}
                      dateTo={dateTo}
                      search={search}
                    />
                  </Box>

                  {loaderBooking ? (
                    <Loader height="50vh" />
                  ) : (
                    <CommonTable
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={handleChangePage}
                      handleChangeRowsPerPage={handleChangeRowsPerPage}
                      tableOnClickRow={onClickTableRow}
                      data={bookingList}
                      tabName={"booking"}
                      onClickMoreIcon={onClickMoreIcon}
                    />
                  )}
                </TabPanel>
                {/* TODO: Has now commented the code for Demo purpose on 31-01-2024 */}
                {/* <TabPanel value="billing" className="frontDeskTable">
                  <Billing />
                </TabPanel> */}
              </TabContext>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default FrontDeskTablist;
